import { render, staticRenderFns } from "./FaqAnswers.vue?vue&type=template&id=c94efea0&"
import script from "./FaqAnswers.vue?vue&type=script&lang=js&"
export * from "./FaqAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports